import { z } from '@authy/lib-common/utils/zod'
import { client, RouterInput } from '@authy/lib-client/trpc'

import { appState } from '@/appState'

type SortType = NonNullable<RouterInput['users']['invitations']['listInvitations']['sort']>

export const SearchSchema = z.object({
    sort: z
        .string()
        .transform((val) => val as Extract<keyof SortType, string>)
        .optional()
        .default('name'),
    sortBy: z.enum(['asc', 'desc']).optional().default('asc'),
})

export type Search = z.infer<typeof SearchSchema>

export const listInvitations = async (search: Search, offset: number, abortController?: AbortController) => {
    return await client.users.invitations.listInvitations.query(
        {
            tenantId: appState.tenant!._id.toString(),
            sort: {
                [search.sort]: search.sortBy,
            },
            limit: 50,
            offset,
            returnCount: offset === 0,
        },
        { signal: abortController?.signal }
    )
}

const allowSortBy = ['name', 'email', 'status'] as const

export const isValidSortBy = (column: string): column is (typeof allowSortBy)[number] =>
    allowSortBy.includes(column as any)
